import { render, staticRenderFns } from "./CustomerUserInfo.vue?vue&type=template&id=47c9846f&scoped=true"
import script from "./CustomerUserInfo.vue?vue&type=script&lang=js"
export * from "./CustomerUserInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c9846f",
  null
  
)

export default component.exports